import * as H from 'history';
import  React from 'react';
import { ClaimController } from '../../../../controllers/ClaimController';
import { ClaimModel } from '../../../../models/ClaimModel';
import { ServicesIPRKnowHowEntry } from '../../../../models/ServicesIPRKnowHowEntry';
import { ISupportSpinner } from '../../../../shared/Ajax';
import { Backdrop } from '../../../../shared/Backdrop';
import { MultiLineField, validateFields } from '../../../../shared/fields';
import { Option } from '../../../../shared/fields/Options';
import { Icon } from '../../../../shared/Icon';
import { Table } from '../../../../shared/table';
import { SaveCancelButtons } from '../../controls/SaveCancelButtons';
import { ScheduleInstructions } from '../../controls/ScheduleInstructions';
import { calculateServicesIPRKnowHowTotal, servicesIPRKnowHowEntryColumns, ServicesIPRKnowHowEntryDetails, sortServicesIPRKnowHow } from './ServicesIPRKnowHowEntryDetails';
import { ScheduleTypes } from '../../../../shared/Utility';

export interface ServicesIPRKnowHowPageProps {
    history: H.History
    model: ClaimModel
    markets: Option<string>[]
    onChange: { (changes: Partial<ClaimModel>, callback?: { (): any }): any }
}

export interface ServicesIPRKnowHowPageState {
    loading: boolean
    servicesIPRKnowHowEntries: ServicesIPRKnowHowEntry[]
}

export class ServicesIPRKnowHowPage extends React.Component<ServicesIPRKnowHowPageProps, ServicesIPRKnowHowPageState> implements ISupportSpinner {
    ajax: ClaimController
    table: Table<ServicesIPRKnowHowEntry>
    serviceDescription: MultiLineField

    constructor(props: ServicesIPRKnowHowPageProps) {
        super(props);

        this.ajax = new ClaimController();

        this.state = {
            loading: false,
            servicesIPRKnowHowEntries: props.model.servicesIPRKnowHowEntries ? props.model.servicesIPRKnowHowEntries.slice() : []
        }
    }

    componentWillUnmount() {
        this.ajax.cancel();
    }

    toggleSpinner(on: boolean, callback: { (): any }): void {
        this.setState({ loading: on }, callback);
    }

    save = () => {
        validateFields(res => {
            if (res) {
                this.table.saveAndClose(res => {
                    if (res) {
                        if (this.state.servicesIPRKnowHowEntries.filter(r => r.invalid).length == 0) {
                            this.props.onChange({ servicesIPRKnowHowEntries: this.state.servicesIPRKnowHowEntries }, () => {
                                this.ajax.updateSchedules(this, this.props.model, ScheduleTypes.ServicesIPRKnowHow,() => {
                                    this.props.history.goBack();
                                })
                            });
                        }
                        else {
                            alert("Please correct records marked with the warning sign.");
                        }
                    }
                });
            }
        },
            this.serviceDescription
        );
    }    

    render() {
        let columns = [...servicesIPRKnowHowEntryColumns(this.props.markets)];

        const invalidRows = this.state.servicesIPRKnowHowEntries.filter(r => r.invalid).length > 0;
        if (invalidRows) {
            columns.splice(0, 0, { name: "", content: d => d.invalid ? <Icon type="warning" /> : <span /> });
        }

        var sortedServicesIPRKnowHow = this.state.servicesIPRKnowHowEntries.slice();
        sortedServicesIPRKnowHow.sort((a, b) => sortServicesIPRKnowHow(a, b));

        return <>
            <SaveCancelButtons onCancel={this.props.history.goBack} onSave={this.save} />
            
            <ScheduleInstructions
                title="Export earnings - Services/Intellectual property rights/Know-how"
                showEarningsAlert={true}
                helpLink="https://www.austrade.gov.au/ArticleDocuments/6917/Guide-to-Schedule-10B.pdf.aspx" />

            <MultiLineField ref={r => this.serviceDescription = r}
                id="serviceDescription"
                label="Fully describe the Services/Intellectual property rights/Know-how"
                value={this.props.model.serviceIPRKnowHowDescription}
                onChange={serviceIPRKnowHowDescription => this.props.onChange({ serviceIPRKnowHowDescription })}
                required={true}
                maxLength={255}
            />            

            <Table<ServicesIPRKnowHowEntry>
                id="table"
                label="Schedule 10B: Export earnings - Services/IP rights/Know-how"
                ref={r => this.table = r}
                value={sortedServicesIPRKnowHow}
                onChange={servicesIPRKnowHowEntries => this.setState({ servicesIPRKnowHowEntries })}
                columns={columns}
                renderSection={(p, i) => <ServicesIPRKnowHowEntryDetails {...p} markets={this.props.markets} claim={this.props.model} />}
                importUrl='/api/servicesiprknowhow/import'
                exportUrl='/api/servicesiprknowhow/export'
                match={(a, b) => a.id == b.id}
                total={calculateServicesIPRKnowHowTotal}
                allowEdit={true}
                allowImport={true}
                invalidRows={invalidRows}
            />

            <SaveCancelButtons onCancel={this.props.history.goBack} onSave={this.save} />

            <Backdrop on={this.state.loading} />
        </>
    }
}